import { JobQuestTop } from "./pages/JobQuestTop";
import { QuestBoard } from "./pages/QuestBoard";
import { QuestDetail } from "./pages/QuestDetail";
import { QuestApply } from "./pages/QuestApply";
import { QuestLayout } from "./components/QuestLayout";
import { QuestLoadState } from "./components/QuestPrimitives";

export function JobQuestRouter() {
  const path = window.location.pathname.replace(/\/+$/, "");
  if (path === "/job-quest") return <JobQuestTop />;
  if (path === "/job-quest/board") return <QuestBoard />;
  const match = /^\/job-quest\/quests\/([1-9][0-9]{0,5})(\/apply)?$/.exec(path);
  if (match)
    return match[2] ? (
      <QuestApply number={Number(match[1])} />
    ) : (
      <QuestDetail number={Number(match[1])} />
    );
  return (
    <QuestLayout current="detail">
      <QuestLoadState status="missing" message="" retry={() => {}} />
    </QuestLayout>
  );
}
